require("@babel/polyfill");
require("./details.scss");
import StatePrice from "./state-price";

(function ($) {
  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
    if (typeof (statePrices) !== 'undefined' && Array.isArray(statePrices) && statePrices.length > 0) {
      (new StatePrice(statePrices)).init();
    }
  });
})(jQuery);